import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { CAMPAIGN_STATUS_OPTIONS } from "../../../../../../../constants/campaignDropdown";
import "./status-dialog.scss";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface StatusDialogProps {
  open: boolean;
  onClose: () => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  handleSaveStatus: () => void;
}

const StatusDialog: React.FC<StatusDialogProps> = ({
  open,
  onClose,
  statusFilter,
  setStatusFilter,
  handleSaveStatus,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      slotProps={{
          paper: {
            sx: {
              width: isMobile ? "90%" : "552px",
              maxWidth: "95vw",
              minHeight:  "108px",
              borderBottomLeftRadius: '30px',
              borderBottomRightRadius: '30px',
              overflowY: "inherit",
              paddingBottom: "30px",
              top: 0,
              margin: 0,
              position: "absolute",
            },
          },
        }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Typography
          variant="h6"
          textAlign="left"
          sx={{
            mb: 3,
            borderBottom: "1px solid #E1E1E1",
            pl: 4,
            p: 1,
            fontWeight: "600 !important",
          }}
        >
          Update Campaign Member Status
        </Typography>
        <div className="campaign-modal-select">
          <span className="status-span">Select Status</span>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            size="small"
            fullWidth
          >
            {CAMPAIGN_STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.value}
              </MenuItem>
            ))}
          </Select>
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", mt: 2, m: 2 }}>
        <button onClick={onClose} className="cancel-button half-width">
          Cancel
        </button>
        <button
          onClick={handleSaveStatus}
          className="cancel-button next-button-wrapper half-width"
        >
          Save
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusDialog;
